export const customerAddressFragment = `
  fragment CustomerAddressFragment on CustomerAddress {
    id
    firstName
    lastName
    name
    address1
    address2
    city
    province
    zoneCode
    zip
    country
    phoneNumber
  }
`;
